export default __webpack_public_path__ + "static/media/logo-usados.35774b12.webp";